import React, { FC } from 'react';
import styled from 'styled-components';

import { FULL_VH } from 'components/Common';
import i18n from 'i18n';
import Typography from './Typography';

const ErrorContainer = styled.div`
  background: var(--sys-color--surface);
  height: ${FULL_VH}px;
  word-wrap: break-word;
  width: 100vw;
  &:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  > div {
    display: inline-block;
    max-width: calc(100% - 20px);
    padding: 10px;
    text-align: center;
    vertical-align: middle;
  }
`;

export const ErrorPage: FC<any> = ({ children }) => (
  <ErrorContainer>
    <div>
      <Typography variant="titleMediumEmphasized" color="var(--sys-color--on-surface)">
        {i18n('component.ErrorPage.commonErrorText')()}
      </Typography>
      <Typography variant="titleMediumEmphasized" color="var(--sys-color--on-surface)">
        {children}
      </Typography>
    </div>
  </ErrorContainer>
);
